// src/services/profileDetailsApi.js — the browser's side of "Profile details"
// (the phone's twin is services/profileDetailsApi.ts). Everything goes through
// the server (profileDetailsRoutes.js): it alone knows who is a friend, so it
// alone may hand out a person's details.
import { auth } from '../config/firebase';
import { BACKEND_URL } from './socket';
import { cleanDetails } from './profileDetails';

async function call(path, body) {
  let token = null;
  try { token = await auth.currentUser?.getIdToken(); } catch { token = null; }
  if (!token) return { ok: false };
  try {
    const res = await fetch(`${BACKEND_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    });
    let j = null;
    try { j = await res.json(); } catch { j = null; }
    if (!res.ok || !j || j.ok === false) return { ok: false, status: res.status || 500, error: (j && j.error) || '' };
    return { ...j, ok: true };
  } catch { return { ok: false }; }
}

const known = new Map();
const subs = new Set();
export const cachedDetails = (uid) => known.get(String(uid)) || null;
export function onDetailsChange(fn) { subs.add(fn); return () => subs.delete(fn); }

export async function fetchDetails(uid) {
  const r = await call('/api/profile/details', { uid });
  if (!r.ok) return null;
  const v = { details: cleanDetails(r.details), relation: r.relation || 'stranger', legacy: !!r.legacy };
  known.set(String(uid), v);
  return v;
}
export async function saveDetails(uid, details) {
  const r = await call('/api/profile/details/save', { details });
  if (!r.ok) return null;
  const clean = cleanDetails(r.details);
  known.set(String(uid), { details: clean, relation: 'owner', legacy: false });
  subs.forEach((fn) => { try { fn(String(uid)); } catch { /* a listener's own */ } });
  return clean;
}
export async function searchOrgs(kind, q) {
  const lang = (navigator.language || 'en').slice(0, 2);
  const r = await call('/api/profile/orgs', { kind, q, lang });
  return r.ok && Array.isArray(r.hits) ? r.hits : [];
}
export async function searchPlaces(q) {
  const lang = (navigator.language || 'en').slice(0, 2);
  const r = await call('/api/profile/places', { q, lang });
  return r.ok && Array.isArray(r.hits) ? r.hits : [];
}
